(() => {
  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest('[data-fuh-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (cartLink && drawer?.open) {
      event.preventDefault();
      drawer.open(cartLink.closest('[data-fuh-toast]') ? document.getElementById('cart-icon-bubble') : cartLink);
    }
  });
  const bubble = document.getElementById('cart-icon-bubble');
  const updateCount = () => {
    const count = bubble?.querySelector('[data-cart-count]')?.dataset.cartCount
      || bubble?.querySelector('.cart-count-bubble [aria-hidden="true"]')?.textContent || '0';
    document.querySelectorAll('[data-fuh-count]').forEach(el => { el.textContent = count;
      el.hidden = Number(count) === 0;
      el.closest('[data-fuh-cart]')?.setAttribute('aria-label', `السلة — ${count} منتجات`); });
  };
  if (bubble) { new MutationObserver(updateCount).observe(bubble, { childList: true, subtree: true }); updateCount(); }
  const desktop = window.matchMedia('(min-width: 750px)');
  const setFooterGroups = () => document.querySelectorAll('.fuh-footer__group').forEach(group => { group.open = desktop.matches; });
  setFooterGroups();
  desktop.addEventListener('change', setFooterGroups);
  document.addEventListener('shopify:section:load', setFooterGroups);

  document.addEventListener('fuh:cart-added', () => {
    updateCount();
    document.querySelectorAll('[data-fuh-count]').forEach(badge => {
      badge.classList.remove('fuh-count-pulse');
      requestAnimationFrame(() => badge.classList.add('fuh-count-pulse'));
    });
  });

  const sticky = document.querySelector('.fuh-sticky-buy');
  const info = document.querySelector('main product-info[id^="MainProduct-"]');
  if (!sticky || !info) return;
  const stickyButton = sticky.querySelector('[data-fuh-buy]');
  let mainButtonVisible = true;
  const sync = () => {
    const button = info.querySelector('product-form button[name="add"]');
    if (!button) { sticky.hidden = true; return; }
    stickyButton.disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
    stickyButton.textContent = button.querySelector('span')?.textContent.trim() || button.textContent.trim();
    const price = info.querySelector('.price--on-sale .price-item--sale') || info.querySelector('.price__regular .price-item--regular');
    if (price) sticky.querySelector('[data-fuh-price]').textContent = price.textContent.trim();
    sticky.hidden = mainButtonVisible || info.getBoundingClientRect().top > window.innerHeight;
  };
  stickyButton.addEventListener('click', () => {
    const button = info.querySelector('product-form button[name="add"]');
    if (button && !button.disabled) button.click();
  });
  const buyArea = info.querySelector('product-form');
  if (buyArea) new IntersectionObserver(entries => { mainButtonVisible = entries[0].isIntersecting; sync(); }, { threshold: 0 }).observe(buyArea);
  new MutationObserver(sync).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
  sync();
})();
